
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scheduling",
      function () {
        return require("private-next-pages/scheduling/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scheduling"])
      });
    }
  